<template>
  <div class="questionLists">
    <van-tabs
      v-model="type"
      sticky
      color="#1890FF"
      title-active-color="#1890FF"
      @click.capture="changeTab"
    >
      <van-tab
        v-for="(item, index) in tabLists"
        :key="index"
        :title="item.title"
      >
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            finished-text=""
            @load="onLoad"
          >
            <div class="list-box">
              <div class="list-bd" v-for="(item, index) in lists" :key="index">
                <div class="list-left">
                  <p class="title">
                    <textarea
                      class="textarea-auto"
                      placeholder="请输入记录名称"
                      maxlength="30"
                      @input="inputBlank"
                      v-model="item.desc"
                      v-if="item.editAble"
                    ></textarea>
                    <span v-else>{{ item.desc }}</span>
                  </p> 
                  <p class="desc">{{item.expend_time}} {{item.t_start}}</p>
                </div>
                <div class="list-right">
                  <div v-if="item.editAble" class="save-btn">
                     <span @click="saveEdit(index)">保存</span>
                     <span @click="cancelEdit(index)">取消</span>
                  </div>
                  <template v-else>
                    <img
                      @click="editClick(index, item.qid)"
                      class="edit-icon"
                      src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220308/158b6842d5dcbba4ca56d1497c7ac37c.svg"
                      alt=""
                    />
                    <img
                      @click="deleteItem(index, item.timer_id)"
                      class="del-icon"
                      src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220308/7ce41b06f42a480b88481d37418e9016.svg"
                      alt=""
                    />
                  </template>
                </div>
              </div>
            </div>
          </van-list>
          <div class="noData" v-if="!lists.length">
            <div>暂无记录</div>
          </div>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import questionOnly from "@/utils/questionOnly";
import api from "@/utils/api";
import Contact from "@/components/contact";
import NavBar from "@/components/navbar";
import FooterTab from "@/components/footerTab";
import { Dialog, Toast } from "vant";
import {
  getToken,
  setShareInfo,
  reLogin,
  deepClone,
  checkWords,
  formatDate,
  timestampToDate
} from "@/utils/common";

export default {
  data() {
    return {
      tabsIndex: "question",
      showContact: false,
      type: 0,
      refreshing: false,
      loading: false,
      finished: true,
      pageSize: 50, //每页请求的数量
      total: 0, //总共的数据条数
      itemList: [],
      page: 1,
      lists: [],
      tabLists: [
        { title: "正计时记录", type: 2 },
        { title: "倒计时记录", type: 0 }
      ],
      isInApp: wemeet.app.isTMWebview(),
      active: 0,
      ori_list: []
    };
  },
  mounted() {
    if (this.isInApp) {
      setShareInfo(false);
    } else {
      if (!getToken()) return reLogin();
    }
  },
  destroyed() {},
  methods: {
    inputBlank(e) {},
    editClick(index) {
      let copy = deepClone(this.lists);
      copy[index].pre_desc = this.lists[index].desc;
      copy[index].editAble = true;
      this.lists = copy;
    },
    async saveEdit(index) {
      if(this.lists[index].desc == '') return Toast('请输入记录名称')
      let res = await checkWords(this.lists[index].desc);
      if (res) {
        this.handleItem("edit", index);
      }
    },
    cancelEdit(index) {
      let copy = deepClone(this.lists);
      copy[index].editAble = false;
      copy[index].desc = copy[index].pre_desc;
      this.lists = copy;
    },
    handleItem(type, index) {
      questionOnly
        .post("/xcx/ques/v1/meeting/timer/update", {
          access_token: getToken(),
          meet_id: this.$store.state.meetingInfo.meet_id,
          timer_id: this.lists[index].timer_id,
          desc: this.lists[index].desc,
          update_type: 1
        })
        .then(res => {
          if (res.sta == 0) {
            let copyData = deepClone(this.lists);
            copyData[index].desc = this.lists[index].desc;
            copyData[index].editAble = false;
            this.lists = copyData;
            Toast("更新成功");
          } else if (res.sta == -1) {
            alert(res.msg);
          }
        });
    },
    deleteItem(index, timer_id) {
      Dialog.confirm({
        title: '',
        message: '是否删除当前记录',
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        confirmButtonColor: '1890ff'
      })
        .then(() => {
          questionOnly
            .post("/xcx/ques/v1/meeting/timer/remove", {
              access_token: getToken(),
              timer_id,
              meet_id: this.$store.state.meetingInfo.meet_id
            })
            .then(res => {
              if (res.sta == 0) {
                let copyData = deepClone(this.lists);
                copyData.splice(index, 1);
                this.lists = copyData;
                this.total = this.total - 1;
                Toast("删除成功");
              } else {
                Toast(res.msg);
              }
            });
        })
        .catch();
    },
    toIntro() {
      this.$router.push({
        name: "intro"
      });
    },
    handleContact() {
      this.showContact = !this.showContact;
    },
    onRefresh() {
      this.getList(1, "chageType");
    },
    changeTab(refresh = 0) {
      this.total = 0;
      this.lists = [];
      this.getList(1, "chageType", refresh);
    },
    onLoad() {
      this.getList(this.page + 1);
    },
    getList(page = 1, changeType) {
      this.page = page;
      let param = {
        access_token: getToken(),
        page,
        count: this.pageSize,
        meet_id: this.$store.state.meetingInfo.meet_id,
        timer_type: this.type
      };
      questionOnly.get("/xcx/ques/v1/meeting/timer/list", param).then(res => {
        this.loading = false;
        this.refreshing = false;
        if (res.sta == 0) {
          if (!res.data.lists.length) {
            this.finished = true;
          } else {
          res.data.lists.map((item)=> {
            item.t_start = formatDate(new Date(item.t_start * 1000), "yyyy-MM-dd HH:mm:ss");
            item.expend_time = timestampToDate(item.expend_time, 2)
          })
          this.lists = changeType
            ? res.data.lists
            : this.lists.concat(res.data.lists);
            this.finished = false;
          }
          this.ori_list = deepClone(this.lists)
          this.total = res.data.total;
          if(this.lists.length == res.data.total || this.lists.length == 100) {
             this.finished = true;
          }
        } else if (res.sta === -500) {
          reLogin();
        } else {
          Toast(res.msg);
        }
      });
    },
  },
  components: { Contact, NavBar, FooterTab },

  async created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.timeRecord-wrap {
  width: 100vw;
  max-width: 414px;
  margin: 0 auto;
  min-height: 100vh;
  background: #fff;
  position: relative;
}

.list-box {
}
.list-title {
  font-size: rem(34);
  font-weight: 900;
  padding: rem(20) 0 rem(40);
  color: #333;
}
.list-bd {
  position: relative;
  display: flex;
  background: #fff;
  padding: rem(50) rem(20) 0;
  cursor: pointer;
  min-height: rem(100);
  justify-content: space-between;
  .list-left {
    flex: 1;
    margin-right: rem(30);
    .title {
      font-size: rem(30);
      line-height: rem(45);
    }
    .desc {
      font-size: rem(28);
      line-height: rem(42);
      margin-top: rem(8);
      color: #999999;
    }
    .textarea-auto {
      min-height: rem(115);
      line-height: rem(45);
      flex: 1;
      border: none;
      background: #f2f2f7;
      padding: rem(10) rem(20);
      width: 100%;
      box-sizing: border-box;
      font-size: rem(30);
      border-radius: rem(8);
      resize: none
    }
  }
  .list-right {
    min-width: rem(130);
    .edit-icon,
    .del-icon {
      width: rem(40);
      height: rem(40);
    }
    .del-icon {
      margin-left: rem(10);
    }
    .save-btn {
      display: flex;
      flex-direction: column;
      span{
        font-size: rem(30);
        color: #ffffff;
        background: #1890ff;
        width: rem(100);
        height: rem(50);
        line-height: rem(50);
        border-radius: rem(8);
        text-align: center;
        cursor: pointer;
      }
      span:last-child{
        color: #262626;
        background: #F2F2F7;
        margin-top: rem(18);
      }
    }
  }
}
.list-bd:first-child {
  padding-top: rem(60);
}

.top10 {
  top: rem(10);
}
.text-red {
  color: #ff7070 !important;
}
.noData {
  // min-height: calc(100vh - 44px);
  text-align: center;
  padding: rem(60) rem(30);
  box-sizing: border-box;
  line-height: rem(48);
  font-size: rem(28);
  position: relative;
  color: #666666;
}
.noData .code {
  width: rem(420);
  margin-top: rem(60);
}
/* 模版中心 */
.template-center-left {
  flex: 1;
}
.template-enter {
  display: flex;
  align-items: center;
  margin: rem(16) 0;
}
.template-enter-title {
  font-weight: 700;
  font-size: rem(34);
  line-height: rem(50);
  color: #262626;
  margin-right: rem(20);
}
.template-des {
  font-size: rem(28);
  line-height: rem(28);
  color: #999999;
}
.template-enter img {
  width: rem(50);
  height: rem(50);
}
.template-center-right {
  width: rem(240);
  height: rem(130);
}
.createCard {
  margin: rem(20) 0 rem(20);
}
.contact-wrapper {
  padding-bottom: 60px;
}
.contact {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 50px;
}
.toIntro {
  cursor: pointer;
}
.tip {
  height: rem(76);
  line-height: rem(76);
  background: rgba(222, 239, 255, 0.6);
  box-shadow: 0 rem(10) rem(16) #f4f6fa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 rem(30);
  font-size: rem(24);
  cursor: pointer;
}
.refresh-icon {
  width: rem(32);
  height: rem(32);
  margin-right: rem(10);
}
</style>



// WEBPACK FOOTER //
// src/pages/timer/timerRecord.vue